<template>
    <div name="soldoc-review" class="soldoc-review" id="soldoc-review">
		<div class="inner-div">
            <span class="d-title">생생한 후기를<br> 확인하세요</span>
            <span class="d-sub-title">솔닥을 먼저 경험한 고객님들의<br> 생생한 후기를 만나보세요</span>
        </div>
        <div class="inner-div2">
			<div class="slider-container">
				<div class="slider-area">
					<div class="slider-wrapper" ref="sliderWrapper" @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd">
						<div class="review-card"
							v-for="card in cards" :key="card.id">
							<div class="header-area">
								<img :src="card.icon" :alt="card.iconAlt" />
								<div class="title-area">
									<div class="category">{{ card.category }}</div>
									<div class="tag" :class="card.tagClass">{{ card.tag }}</div>
								</div>
							</div>
							<p class="content-area">{{ card.content }}</p>
							<div class="footer-area">{{ card.hospital }}</div>
						</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    name:'soldoc-review',
    data: function()
    {
        return {
			startX: 0,
			startY: 0,
			moveX: 0,
			moveY: 0,
			movingDirection: null,
			isMoved: false,
			currentIndex: 0,
			// currentIndex: 1,
			cards: [
				{
				id: 0,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'30대 여성 바로솔닥',
				category: '30대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바로솔닥을 통해 병원 찾기부터 예약, 결제, 조제약 수령, 서류 발급까지 모든 과정이 편리해졌습니다. 건강 관리에 대한 새로운 패러다임이에요.',
				hospital: '피부과 진료'
				},
				{
				id: 1,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'20대 남성 바로솔닥',
				category: '20대 남성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '이전에는 병원 찾기부터 예약, 결제, 서류 발급 등 복잡한 과정을 거쳐야 했지만, 바로솔닥을 이용하고 그런 과정을 크게 줄일 수 있었습니다.',
				hospital: '가정의학과 진료'
				},
				{
				id: 2,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconAlt:'50대 남성 바로돌봄',
				category: '50대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '어머님 모시고 병원 갈 때마다 연차 쓰고 1시간 이상은 병원에서 대기했는데 기다림 없이 진료 볼 수 있어서 너무 편합니다.',
				hospital: '주야간보호센터'
				},
				{
				id: 3,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'40대 여성 바로솔닥',
				category: '40대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바쁜 일상에서 원하는 시간에 병원 예약을 할 수 있다는 점이 감동적입니다. 이제는 건강관리를 위한 시간과 공간의 제약을 걱정하지 않아도 돼요.',
				hospital: '이비인후과 진료'
				},
				{
				id: 4,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconAlt:'30대 여성 솔닥파트너스',
				category: '30대 여성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '솔닥으로 만나는 환자들 진료를 전용 EMR로 쉽게 관리할 수 있어서 좋습니다.',
				hospital: '피부과 의사'
				},
				{
				id: 5,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconAlt:'70대 여성 바로돌봄',
				category: '70대 여성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '원장님을 편하게 자주 보고 진료받을 수 있어서좋습니다. 항상 친절하게 상세하게 물어봐주셔서 무척 감동했어요.',
				hospital: '주야간보호센터'
				},
				{
				id: 6,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'40대 남성 바로솔닥',
				category: '40대 남성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '바로솔닥으로 진료 예약부터 서류 발급까지 편리하게 이루어져서 정말 만족스럽습니다. 이제 기다릴 필요가 없어서 너무 편해요.',
				hospital: '내과 진료'
				},
				{
				id: 7,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconAlt:'40대 남성 바로돌봄',
				category: '40대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '보호자분들의 만족도가 굉장히 높습니다. 어르신 모시고 병원 방문하던 일들이 없어지며 효율이 증가합니다.',
				hospital: '주야간보호센터 센터장'
				},
				{
				id: 8,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'20대 여성 바로솔닥',
				category: '20대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '내가 원하는 시간을 지정해서 병원을 방문할 수 있어서 만족스럽습니다. 회사에 있더라도 시간 맞춰 진료를 보고 복귀할 수 있기 때문에 잘 이용할 것 같아요.',
				hospital: '이비인후과 진료'
				},
				{
				id: 9,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'30대 여성 바로솔닥',
				category: '30대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '병원마다 일일이 전화해서 진료 가능한 증상을 문의하는 게 무척 번거로웠는데, 솔닥에서는 증상별로 진료 가능한 병원을 찾아볼 수 있어서 만족스럽습니다.',
				hospital: '피부과 진료'
				},
				{
				id: 10,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconAlt:'40대 남성 솔닥파트너스',
				category: '40대 남성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '비대면진료뿐 아니라 대면진료, 요양기관 진료도 가능해서 환자들과의 접점을 늘릴 수 있는 좋은 기회를 얻었습니다.',
				hospital: '피부과 의사'
				},
				{
				id: 11,
				icon: require('../../assets/renew_pc/ico_review02.png'),
				iconAlt:'50대 남성 바로돌봄',
				category: '50대 남성',
				tag: '바로돌봄',
				tagClass: 'tag02',
				content: '신규 상담 오신 보호자분들께서 높은 관심을 보이십니다. 급한 설사, 변비도 진료 보고 약을 받아볼 수 있어 매우 만족합니다.',
				hospital: '주야간보호센터 센터장'
				},
				{
				id: 12,
				icon: require('../../assets/renew_pc/ico_review01.png'),
				iconAlt:'40대 여성 바로솔닥',
				category: '40대 여성',
				tag: '바로솔닥',
				tagClass: 'tag01',
				content: '예진지를 통해 의사선생님과 소통이 원활해졌고, 보다 정확한 진단을 받을 수 있었습니다.',
				hospital: '산부인과 진료'
				},
				{
				id: 13,
				icon: require('../../assets/renew_pc/ico_review03.png'),
				iconAlt:'30대 남성 솔닥파트너스',
				category: '30대 남성',
				tag: '솔닥파트너스',
				tagClass: 'tag03',
				content: '환자 문의 응대 등과 같은 진료 외 업무는 솔닥 전담팀에서 직접 담당해 주셔서 의료진은 진료에만 집중할 수 있는 환경이 조성되는 것 같아요.',
				hospital: '내과 의사'
				},				
			]
		}
    },
    mounted: function()
    {	
        $(window).scroll(function () {
            var height = $(document).scrollTop();
            var contTop = $('.soldoc-review').offset().top;

            var contHeight = height - contTop;
            var winHeight = $(window).height();
            var acviveHeight = contHeight + winHeight;
            // console.log(acviveHeight);
            
            if(acviveHeight < 100 && acviveHeight <= 127)
            {
                $('.soldoc-review .inner-div').css('display', 'none');
                $('.soldoc-review .inner-div2').css('display', 'none');
            } else if(acviveHeight > 127)
            {
                $('.soldoc-review .inner-div').css('display', 'block');
                $('.soldoc-review .inner-div2').css('display', 'block');
            } 
        })
    },
    methods: {
		touchStart(event) {
			this.startX = event.touches[0].clientX;
			this.startY = event.touches[0].clientY;
			this.movingDirection = null;
			this.isMoved = false;
		},
		touchMove(event) {
			if (this.movingDirection === null) {
				const initialDistanceX = Math.abs(this.startX - event.touches[0].clientX);
				const initialDistanceY = Math.abs(this.startY - event.touches[0].clientY);

				this.movingDirection = initialDistanceX > initialDistanceY ? 'horizontal' : 'vertical';
			}
			this.moveX = event.touches[0].clientX;
			if (this.movingDirection === 'vertical') {
				return;
			}

			if (this.movingDirection === 'horizontal') {
				const distanceX = this.startX - event.touches[0].clientX;
				let slideWidth = window.innerWidth < 360 ? (window.innerWidth - 21) : 331;
				let offset = -this.currentIndex * slideWidth - distanceX;
				this.$refs.sliderWrapper.style.transform = `translateX(${offset}px)`;
				this.isMoved = true;
			}
		},
		touchEnd() {
			if (!this.isMoved || this.movingDirection !== 'horizontal') {
				return;
			}
			

			const distance = this.startX - this.moveX;

			if (distance > 165.5 && this.currentIndex < this.cards.length - 1) {
				this.currentIndex++;
			} else if (distance < -165.5 && this.currentIndex > 0) {
				this.currentIndex--;
			}

			let slideWidth = window.innerWidth < 360 ? (window.innerWidth - 21) : 331;
			let finalTransform = -this.currentIndex * slideWidth;
			this.$refs.sliderWrapper.style.transform = `translateX(${finalTransform}px)`;
		},
    }
}
</script>

<style scoped> 
    .soldoc-review{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        position: relative;
        width: 100%;
        height: 741px;
        background: #F3F4F7;
        padding-top: 65px;
        padding-bottom: 120px;
    }
	.inner-div{
		display: none;
		animation: fadeInUp 1s;
	}
	.inner-div2{
		display: none;
		animation: fadeInUp 1s;
	}
	.soldoc-review .inner-div2{
		width: 100%;
		height: 400px;
		padding-top: 37px;
	}
	.soldoc-review .d-title{
		display: block;
		font-size: 32px;
		font-weight: 600;
		text-align: center;
		color: #1A1A1A;
		line-height: 1.3;
	}
	.soldoc-review .d-sub-title{
		display: block;
		margin-top: 20px;
		font-size: 16px;
		font-weight: 400;
		text-align: center;
		color: #666;
		line-height: 1.6;
	}
	.slider-container{
		position: relative;
		flex-direction: row;
		justify-content: center;
		height: 400px;
		margin: 0 auto;
		padding: 0 17px;
		overflow: hidden;
	}

	.slider-wrapper{
		position: relative;
		display: flex;
		flex-direction: row;
		margin: 0 auto;
		transition: transform 0.8s ease-out;
	}
	.review-card{
		flex: 0 0 16.66%; 
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		align-content: flex-start;
		justify-content: space-between;
		min-width: 318px;
		width: 318px;
		height: 326px;
		padding: 38px 24px;
		margin: 16px 6.5px;
		flex-wrap: wrap;
		border-radius: 14px;
		background: #fff;
		box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.15);
		box-sizing: border-box;
	}
	.review-card:first-child{
		margin-left: 16px;
	}

	.soldoc-review .header-area{
		flex: 0 0 auto;
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 80px;
	}
	.soldoc-review .title-area{
		width: calc(100% - 80px);
		margin-left: 16px;
	}
	.soldoc-review .category{
		font-size: 20px;
		font-weight: 600;
		line-height: 1;
		color: #000;
	}
	.soldoc-review .tag{
		display: inline-flex;
		justify-content: center;
		align-items: center;
		min-width: 71px;
		height: 30px;
		margin-top: 10px;
		margin-left: 5px;
		padding: 0px 13px;
		gap: 10px;
		font-size: 14px;
		font-weight: 600;
		color: #333;
		text-align: center;
		border-radius: 6px;
	}
	
	.soldoc-review .tag01{
		background: #E3F5FF;
	}
	.soldoc-review .tag02{
		background: #FFDEAC;
	}
	.soldoc-review .tag03{
		background: #DCE2FF;
	}
	.soldoc-review .content-area{
		flex: 1 1 auto;
		margin-top: 18px;
		font-size: 16px;
		font-weight: 400;
		color: #000;
		line-height: 1.6;
	}
	.soldoc-review .footer-area{
		flex: 0 0 auto;
		height: 16px;
		font-size: 16px;
		font-weight: 400;
		line-height: 1;
		color: #999;
	}


    @media screen and (max-width: 360px){
		.review-card{
			min-width: 100%;
			max-width: 100%;
		}
		.review-card .content-area{
			margin-bottom: 5px;
		}
		.review-card:first-child{
			margin-left: -2px;
		}
        .healthcare .inner-card {
            margin-top: 25px;
            padding-left: 34px;
            padding-right: 34px;
        }
        .healthcare .care-card {
            width: 100%;
            height: auto;
        }
        .healthcare .care-title{
            font-size: 23px;
        }
        .healthcare .care-sub-title{
            margin-top: 12px;
            font-size: 12px;
        }
        .healthcare .label{
            height: 22px;
            font-size: 11px;
        }

        .card-title{
            margin-top: 20px;
            font-size: 19px;
        }
        .sub-text{
            margin-top: 15px;
            font-size: 14px;
        }
        .healthcare .state-area{
            display: block;
            margin-top: 15px;
        }
        .healthcare .state{
            font-size: 11px;
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    /* @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/SoldocReview.vue